module.exports = __webpack_public_path__ + "static/media/productdesign.81cf07bd.svg";